import { inject } from '@angular/core';
import type { CanActivateFn } from '@angular/router';
import { AuthService, SettingPermissionsService } from '@core/services';
import { BiApiService } from '@feature/BI-dashboards/services/bi-api.service';
import { MainDashboardsService } from '@feature/BI-dashboards/services/main-dashboards.service';
import { GroupsPermissionService } from '@feature/settings/services';
import { catchError, forkJoin, map, of } from 'rxjs';

export const mainGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const biApiService = inject(BiApiService);
  const groupsPermissionService = inject(GroupsPermissionService);
  const mainDashboardsService = inject(MainDashboardsService);
  const settingPermissionsService = inject(SettingPermissionsService);

  const dashboards$ = biApiService
    .getDashboardsByAccountId(authService.currentUser()!.id)
    .pipe(
      map(dashboards => {
        mainDashboardsService.userDashboards.next(dashboards);
        return true;
      }),
      catchError(() => of(true)),
    );

  const settingPermissions$ = groupsPermissionService
    .getBiPortalSettingsPermissions(authService.currentUser()!.id)
    .pipe(
      map(permissions => {
        settingPermissionsService.settingScreensPermissions.set(permissions);
        settingPermissionsService.settingScreensPermissions$.next(permissions);
        return true;
      }),
      catchError(() => of(true)),
    );

  return forkJoin([dashboards$, settingPermissions$]).pipe(
    map(() => true),
    catchError(() => of(false)),
  );
};
